import { Component, ElementRef, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { DashboardService } from './dashboard.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as Highcharts from 'highcharts';
import HC_3D from 'highcharts/highcharts-3d';
import * as moment from 'moment';
import * as html2pdf from 'html2pdf.js';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import {trigger,state,style,transition,animate,} from '@angular/animations';



// Initialize 3D module
HC_3D(Highcharts);
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexXAxis,
  ApexPlotOptions,
  ApexStroke,
  ApexTitleSubtitle,
  ApexYAxis,
  ApexTooltip,
  ApexFill,
  ApexLegend,
  ApexGrid,
} from 'ng-apexcharts';
import { DatePipe } from '@angular/common';
import { Options } from 'highcharts';
import { UnitType } from 'dayjs';
import {
  CurrencyUnit,
  UnitToggleService,
} from 'src/app/services/unit-toggle.service';
import { DatafilterService } from 'src/app/services/datafilter.service';

interface Week {
  start: string;
  end: string;
}

export type ChartOption = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  stroke: ApexStroke;
  title: ApexTitleSubtitle;
  tooltip: ApexTooltip;
  fill: ApexFill;
  legend: ApexLegend;
};

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  stroke: ApexStroke;
  title: ApexTitleSubtitle;
  tooltip: ApexTooltip;
  fill: ApexFill;
  legend: ApexLegend;
};

@Component({

  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardNewComponent implements OnInit {
  Highcharts: typeof Highcharts = Highcharts;
  chartOptionsHigh: any;
  chartOptionsMonthWise: any;
  totalExpenditure: any;
  districtHighChart: any;
  districtchartHeight: any;
  fundDetailsHighChart: any;
  @ViewChild('chart') chart: ChartComponent;
  public chartOption: Partial<ChartOption>;

  @ViewChild('charts') chartOne: ChartComponent;
  public chartOptions: any;
  response;

  @ViewChild('chartLine') chartLine: ChartComponent;

  fundDtails: any;
  getAmountSpent: any;
  fundAllocation: any;
  listName = 'over';
  fundList: any;
  fundSpent: any = [];
  districts: any;
  // selectedYear = '';
  fromDate = '';
  toDate = '';
  // selectedMonth = '';
  districtList: any[];
  projectPercentage: any;
  percentage: any[];
  projectFund: any;
  projectCount: any;
  districtCount: any;
  year = [];
  yearList: number[];
  isShowFirstChart: boolean = false;
  isShowSecondChart: boolean = false;
  isShowThirdChart: boolean;
  totalAmountSpent: any;
  totalNoOfBeneficiaries: any;
  projectCountTotal: any;
  beneficiaryCount: any;
  awardBeneficiary: any[];
  pendingBeneficiary: any[];
  fundDetails: boolean;
  spent: any[];
  balance: any[];
  total: any[];
  fundShortageDetails: any;
  disbursementDetails: any;
  data: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      fill: boolean;
      borderColor: string;
      tension: number;
    }[];
  };
  options: any;
  month: any;
  count: any;
  expandedRows = {};
  agencyDetails: any;
  activeIndex;
  visible: any;
  noOfProjects: any = false;
  getNoOfProjects: any;
  totalcount: number;
  isFundExpenditure;
  chartOptionForPie: {
    animationEnabled: boolean;
    title: { text: string };
    data: {
      type: string;
      startAngle: number;
      indexLabel: string;
      yValueFormatString: string;
      dataPoints: { y: number; name: string }[];
    }[];
  };
  optionsforPie: {
    plugins: { legend: { labels: { usePointStyle: boolean; color: string } } };
  };
  dataforPie: {
    labels: string[];
    datasets: {
      data: number[];
      backgroundColor: string[];
      hoverBackgroundColor: string[];
    }[];
  };
  selectProject: any;
  fundReceivedData: any;
  agencyListForFilter;
  ingredient;
  isFundReceived: boolean;
  expenditureList: any;
  agencyList: any;
  agencyPopup: boolean;
  agencyFilter;
  districtPopup: boolean;
  flag: any;
  agencyListAbstract: any;
  getList: any;
  districtListForFilter: any;
  districtFilter: any;
  districtListAbstract: any;
  showPie: boolean;
  fundReceivedDataLength: any;
  popupFromDate = '';
  popuptoDate = '';
  popupExpenditurefromDate = '';
  popupExpendituretoDate = '';
  fundReceivedDataTotal: any;
  noProject: any;
  totalAmountReceived: any;
  amountDisburse: any;
  amountBalance: any;
  tooltipContent: string;
  roleCode: string;
  overallSNA: any;
  disbursementData: any;
  agencyNames: string[];
  courtList: any;
  dayWiseAbstarct: boolean = false;
  // years: number[] = [];
  // months: { name: string; value: number }[] = [];
  // weeks: { start: string; end: string }[] = [];
  selectedWeek: { start: string; end: string } | null = null;
  selectedWeekD: { start: string; end: string } | null = null;

  selectedYearD!: number;
  selectedMonthD!: number;
  // Unit-Toggle

  selectedUnit: CurrencyUnit = 'Crore';
  dialogWidth = '45rem'; // Default small width
  layoutFullWidth = true; 

//year month and weeks
selectedYear: number | null = null;
selectedMonth: number = 0;
selectedWeekIndex: number = 0; // default to 'All Weeks'
weeksByMonth: { [key: string]: Week[] } = {};
weeks: Week[] = [];
weekCount = 0;
years = [2024, 2025, 2026]; // example year list
months = this.dataService.getMonths();
columnCountArray = Array(16).fill(0); 
dialogType: 'agency' | 'district' = 'agency';
clickedName: string = '';



  //download content from ElementRef
  @ViewChild('pdfContent', { static: false }) pdfContent!: ElementRef;
  // @ViewChild('pdfContents', { static: false }) pdfContents!: ElementRef;

  constructor(
    private ds: DashboardService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private unitService: UnitToggleService,
    private dataService: DatafilterService
  ) {
    this.roleCode = localStorage.getItem('roleCode');
  }
  onRowExpand(event: any) {
    console.log(event);
  }
  onRowCollapse(event: any) {}
  expandAll() {
    this.expandedRows = this.fundReceivedData.reduce(
      (acc, p) => (acc[p.id] = true) && acc,
      {}
    );
  }

  collapseAll() {
    this.expandedRows = {};
  }

  // weekCount: number = 0;
  // selectedWeekIndex: number | 'all' = 'all';

/*     years: number[] = [];
  months = [];
  weeks: Week[] = [];
  weekCount = 0;
  selectedYear: number | null = null;
  selectedMonth: number = 0;
  selectedWeekIndex: number | 'all' = 'all';
  weeksByMonth: { [key: string]: Week[] } = {}; // Holds all weeks grouped by "year-month" */
 

  ngOnInit(): void {
    this.getFunds();
    this.getProjectPercentage();
    this.getProjectFundAllocation();
    this.districtWiseCount();
    this.projectByDepartments();
    this.fundShortage();
    // const currentYear = new Date().getFullYear();
    // this.years = [currentYear - 1, currentYear, currentYear + 1];
    // this.selectedYearD = currentYear;
    //this.selectedMonthD = new Date().getMonth() + 1;
    // this.populateMonths();
    // this.onYearChange(this.selectedYearD.toString());
    // this.onMonthChange(this.selectedMonthD.toString());
    const firstDay = new Date(this.selectedYearD, this.selectedMonthD - 1, 1);
    const lastDay = new Date(this.selectedYearD, this.selectedMonthD, 0);
    this.weeks = [];

    this.weeks.push({
      start: firstDay.toLocaleDateString('en-CA'),
      end: lastDay.toLocaleDateString('en-CA'),
    });
    console.log('date', this.weeks);
    //this.selectedWeekD = this.weeks[0];

    //this.search('search');

    const month = 1; // February (0-indexed)
    const year = 2025;
    // this.weeks = this.getWeeksInMonth(year, month);
    this.weekCount = this.weeks.length; // Usually 4 or 5

    // unit-Toggle [part 1]
    this.unitService.unit$.subscribe((unit) => {
      this.selectedUnit = unit;
    });

    //date
    const currentYear = new Date().getFullYear();
    this.years = Array.from({ length: 5 }, (_, i) => currentYear - i);
    this.months = this.dataService.getMonths();
  }

  // unit-Toggle part 2
  onUnitChange(unit: CurrencyUnit) {
    this.selectedUnit = unit;
    this.unitService.setUnit(unit);
  }

/*   search(params?) {
    if (params == 'search') {
      this.fromDate = this.selectedWeekD.start;
      this.toDate = this.selectedWeekD.end;
      let date = {
        fromDate: this.datePipe.transform(this.fromDate, 'yyyy-MM-dd'),
        toDate: this.datePipe.transform(this.toDate, 'yyyy-MM-dd'),
      };
      this.getFunds(date);
      this.getProjectPercentage(date);
      this.getProjectFundAllocation(date);
      this.districtWiseCount(date);
      this.projectByDepartments(date);
      this.fundShortage(date);
      this.getAbstract(this.listName);
    } else {
      this.selectedMonth = null;
      (this.selectedWeekD = null), (this.fromDate = '');
      this.toDate = '';
      this.getFunds();
      this.getProjectPercentage();
      this.getProjectFundAllocation();
      this.districtWiseCount();
      this.projectByDepartments();
      this.fundShortage();
      this.getAbstract(this.listName);
    }
  } */
  fundShortage(date?) {
    this.spinner.show();
    this.ds.fundShortage(date).subscribe((res) => {
      console.log(res);
      this.fundShortageDetails = res.body.data;

      this.spinner.hide();

      console.log(this.fundShortageDetails, 'this.fundShortageDetails');
    });
  }
  getProjectPercentage(date?) {
    this.awardBeneficiary = [];
    this.pendingBeneficiary = [];
    // this.spinner.show()

    this.isShowThirdChart = false;
    this.ds.getSpentAmout(date).subscribe((res) => {
      console.log(res);
      this.beneficiaryCount = res.body.data;

      let awardArr = [];
      let pendingArr = [];
      let award;
      let pending;
      let court;
      let lable = [];
      let courtArr = [];
      this.beneficiaryCount.label.forEach((element, i) => {
        console.log(element);
        lable.push(element.name);
      });
      this.beneficiaryCount.beneficiaries.forEach((element, i) => {
        console.log(element);
        awardArr.push(element.awardedBeneficiaries);
        pendingArr.push(element.pendingBeneficiaries);
        courtArr.push(element.awardedCourtDDs);
      });

      // old districtHighChart with 3 rows
      /* this.districtHighChart = {
        chart: {
          type: 'bar',
        },
        // title: {
        //   text: 'District Vs Beneficiary'
        // },
        xAxis: {
          categories: lable,
          title: {
            text: null,
          },
          gridLineWidth: 1,
          lineWidth: 0,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: null, // or text: ''
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Beneficiaries',
            align: 'high',
          },
          labels: {
            overflow: 'justify',
          },
          gridLineWidth: 0,
        },
        tooltip: {
          valueSuffix: ' Beneficiaries',
        },
        plotOptions: {
          bar: {
            pointPadding: 0.2,
            groupPadding: 0.1,
            pointWidth: 20, // This controls the bar thickness
            dataLabels: {
              enabled: true,
            },
          },
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'top',
          x: -40,
          y: 80,
          floating: true,
          borderWidth: 1,
          backgroundColor:
            Highcharts.defaultOptions.legend?.backgroundColor || '#FFFFFF',
          shadow: true,
        },
        series: [
          {
            name: 'award',
            type: 'bar',
            data: awardArr,
          },
          {
            name: 'pending',
            type: 'bar',
            data: pendingArr,
          },
          {
            name: 'court',
            type: 'bar',
            data: courtArr,
          },
        ],
      }; */

      // updated districtHighChart with 1 row
      this.districtHighChart = {
        chart: {
          type: 'bar',
        },
        title: {
          text: null,
        },
        xAxis: {
          categories: lable, // e.g. ['Chennai', 'Madurai', ...]
          title: {
            text: null,
          },
          gridLineWidth: 1,
          lineWidth: 0,
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Total Beneficiaries',
            align: 'high',
          },
          labels: {
            overflow: 'justify',
          },
          gridLineWidth: 0,
          stackLabels: {
            enabled: true,
            formatter: function () {
              return this.total;
            },
          },
        },
        tooltip: {
          shared: true,
          pointFormat:
            '<span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>',
        },
        plotOptions: {
          series: {
            stacking: 'normal',
            dataLabels: {
              enabled: true,
            },
          },
          bar: {
            pointPadding: 0.1,
            groupPadding: 0.05,
            pointWidth: 25,
          },
        },
        legend: {
          reversed: true,
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'bottom',
          itemMarginTop: 5,
        },
        credits: {
          enabled: false,
        },
        colors: ['#4caf50', '#f9a825', '#e53935'], // Optional: green, yellow, red
        series: [
          {
            name: 'Court Deposit',
            type: 'bar',
            data: courtArr,
          },
          {
            name: 'Pending',
            type: 'bar',
            data: pendingArr,
          },
          {
            name: 'Disbursed',
            type: 'bar',
            data: awardArr,
          },
        ],
      };

      this.isShowFirstChart = true;
      const numberOfSeries = 3; // award, pending, court
      const baseRowHeight = 25; // adjust as needed for visual spacing
      const standardHeight = 400; // set your standard height when rowCount < 5

      let rowCount = this.beneficiaryCount.label.length;

      if (rowCount < 5) {
        this.districtchartHeight = standardHeight + 'px';
      } else {
        this.districtchartHeight =
          rowCount * baseRowHeight * numberOfSeries + 'px';
      }
    });
  }

  getFundDetailsHighChart() {
    this.fundDetailsHighChart = {
      chart: {
        type: 'column',
      },
      title: {
        text: 'Fund Details',
      },

      xAxis: {
        categories: ['USA', 'China', 'Brazil', 'EU', 'Argentina', 'India'],
        crosshair: true,
        accessibility: {
          description: 'Countries',
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: '1000 metric tons (MT)',
        },
      },
      tooltip: {
        valueSuffix: ' (1000 MT)',
      },
      // plotOptions: {
      // 	column: {
      // 		pointPadding: 0.2,
      // 		borderWidth: 0
      // 	}
      // },
      series: [
        {
          name: 'Corn',
          data: [387749, 280000, 129000, 64300, 54000, 34300],
        },
        {
          name: 'Wheat',
          data: [45321, 140000, 10000, 140500, 19500, 113500],
        },
      ],
    };
  }
  //old pattern
  /* getProjectFundAllocation(date?) {
    this.spent = [];
    this.balance = [];
    this.total = [];
    this.ds.getProjectFund(date).subscribe((res) => {
      this.projectFund = res.body.data;

      this.projectFund.fundDetails.forEach((element, i) => {
        this.spent.push(parseFloat((element.spent / 10000000).toFixed(2)));
        this.balance.push(parseFloat((element.balance / 10000000).toFixed(2)));
      });

      this.fundDetailsHighChart = {
        chart: {
          type: 'column',
        },

        title: {
          text: null, // or text: ''
        },

        xAxis: {
          categories: this.projectFund.requestioningBody,
          crosshair: true,
          accessibility: {
            description: 'Project',
          },
        },
        yAxis: {
          min: 0,
          // title: {
          // 	text: '1000 metric tons (MT)'
          // }
        },
        // tooltip: {
        // 	valueSuffix: ' (1000 MT)'
        // },
        // plotOptions: {
        // 	column: {
        // 		pointPadding: 0.2,
        // 		borderWidth: 0
        // 	}
        // },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: 'Spent',
            data: this.spent,
            color: '#ff4560',
          },
          {
            name: 'Balance',
            data: this.balance,
            color: '#00e396',
          },
        ],
      };
      //this.getFundDetailsHighChart()
    });
  } */

    //new updated 3d effect
    getProjectFundAllocation(date?) {
  this.spent = [];
  this.balance = [];
  this.total = [];

  this.ds.getProjectFund(date).subscribe((res) => {
    this.projectFund = res.body.data;

    this.projectFund.fundDetails.forEach((element) => {
      this.spent.push(parseFloat((element.spent / 10000000).toFixed(2)));
      this.balance.push(parseFloat((element.balance / 10000000).toFixed(2)));
    });

    this.fundDetailsHighChart = {
  chart: {
    type: 'column',
    options3d: {
      enabled: true,
      alpha: 10,
      beta: -15,
      depth: 50,
      viewDistance: 25
    },
    backgroundColor: 'transparent',
  },
  title: { text: null },
  xAxis: {
    categories: this.projectFund.requestioningBody,
    crosshair: true,
    labels: {
      style: {
        fontSize: '12px',
        fontWeight: 'bold'
      }
    }
  },
  yAxis: {
    min: 0,
    title: { text: 'Amount (in Crores)' },
    labels: { format: '{value} Cr' },
    stackLabels: {
      enabled: true,
      style: {
        fontWeight: 'bold',
        color: (Highcharts.defaultOptions.title.style &&
          Highcharts.defaultOptions.title.style.color) || 'black',
        textOutline: 'none'
      },
      formatter: function () {
        return this.total;
      }
    }
  },
  tooltip: {
    shared: true,
    headerFormat: '<br/><b>{point.key}</b><br><span style="font-size: 10px; font-weight: bold">Total Received</span><br>',
    pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y} Cr</b><br/>'
  },
  legend: {
    align: 'center',
    verticalAlign: 'bottom',
    layout: 'horizontal'
  },
  plotOptions: {
    column: {
      depth: 25,
      stacking: 'normal', 
      borderWidth: 0,
      dataLabels: {
        enabled: true,
        style: {
          fontWeight: 'bold',
          fontSize: '12px'
        }
      }
    }
  },
  credits: { enabled: false },
  series: [
    {
      name: 'Amount Disbursed',
      data: this.spent,
      color: '#ff4560'
    },
    {
      name: 'Balance',
      data: this.balance,
      color: '#00e396'
    }
  ]
};


  });
}


  // getDrillDown(data, flag) {
  //   this.agencyPopup = true;
  //   if (flag == 'agency') {
  //     this.agencyList = data.requestioningBodyDrillDown;
  //   } else if (flag == 'district') {
  //     this.districtPopup = true;
  //     this.agencyList = data.districtDrillDown;
  //   }
  // }
  getDrillDown(data, flag) {
  this.dialogType = flag; // Save who triggered the dialog
  this.clickedName = flag === 'district' ? data.districtName : data.agencyName;
  this.agencyList = flag === 'district' ? data.districtDrillDown : data.requestioningBodyDrillDown;
  this.agencyPopup = true;
}

  expenditure(filter?) {
    this.activeIndex = 0;

    if (filter) {
      let param = {
        fromDate: this.datePipe.transform(
          this.popupExpenditurefromDate,
          'yyyy-MM-dd'
        ),
        toDate: this.datePipe.transform(
          this.popupExpendituretoDate,
          'yyyy-MM-dd'
        ),
      };
      this.spinner.show();
      this.ds.expenditure(param).subscribe((res) => {
        this.isFundExpenditure = true;
        this.expenditureList = res.body.data;
        this.spinner.hide();
      });
    } else {
      this.popupExpenditurefromDate = '';
      this.popupExpendituretoDate = '';
      this.spinner.show();
      this.ds.expenditure().subscribe((res) => {
        this.isFundExpenditure = true;
        this.spinner.hide();
        this.expenditureList = res.body.data;
      });
    }
  }
  over(data) {
    this.tooltipContent = `Created on:${this.datePipe.transform(
      data.createdOn,
      'dd-MM-yyyy'
    )}
		No of districts:${data.noOfDistricts}
		Administrative sanction date:${this.datePipe.transform(
      data.administrativeSanctionDate,
      'dd-MM-yyyy'
    )} 
		Virtual Account Number: ${data.virtualAccountNumber}
	  `;
  }
  districtWiseCount(date?) {
    this.ds.districtCount(date).subscribe((res) => {
      this.response = res.body;
      const months = this.response.data.months;
      const converted = this.response.data.agency.map(
        (item: any) => item.totalExpenditure
      );
      this.totalExpenditure = [
        0, 898513, 91144, 881456, 898513, 898513, 898513, 8614, 0, 0, 751488,
        898513,
      ];
      // this.totalExpenditure = converted.map(value =>
      // 	parseFloat((value / 10000000).toFixed(2))
      //   );
      this.totalExpenditure = this.totalExpenditure.map((value) =>
        parseFloat((value / 10000000).toFixed(2))
      );

      this.getMonthWiseHighChart();
      // this.data = {
      // 	labels: months,
      // 	datasets: [
      // 		{
      // 			label: 'Expenditure',
      // 			data: totalExpenditure,
      // 			fill: false,
      // 			borderColor: 'rgb(235, 49, 182)', // Line color
      // 			tension: 0.3
      // 		}
      // 	]
      // };

      // this.options = {
      // 	responsive: true,
      // 	interaction: {
      // 		mode: 'index',
      // 		intersect: false,
      // 	},
      // 	plugins: {
      // 		tooltip: {
      // 			callbacks: {
      // 				title: (tooltipItems) => {
      // 					const index = tooltipItems[0].dataIndex;
      // 					const agencyExpenditures = this.response.data.agency[index].agencyExpenditures;
      // 					return this.formatAgencyExpenditures(agencyExpenditures, index);
      // 				},
      // 				label: () => ''
      // 			}
      // 		}
      // 	}
      // };
    });
  }

  getMonthWiseHighChart() {
    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    const currentMonthIndex = new Date().getMonth();

    const monthLabels: string[] = [];
    for (let i = 0; i < 12; i++) {
      const index = (currentMonthIndex + i) % 12;
      monthLabels.push(monthNames[index]);
    } 

    //old months spens graphs
    /* const chartData = monthLabels.map((month, i) => [
      month,
      this.totalExpenditure[i],
    ]);
    this.chartOptionsMonthWise = {
      chart: {
        type: 'column',
        options3d: {
          enabled: true,
          alpha: 15,
          beta: 15,
          depth: 50,
          viewDistance: 25,
        },
      },
      title: {
        text: null, // or text: ''
      },
      // title: {
      //   text: 'Month Wise expenditure'
      // },

      // plotOptions: {
      //   column: {
      // 	depth: 25
      //   }
      // },
      xAxis: {
        type: 'category',
      },
      yAxis: {
        title: {
          enabled: false,
        },
      },
      tooltip: {
        headerFormat: '<b>{point.key}</b><br>',
        pointFormat: 'Expenditure: {point.y} Crores',
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          type: 'column',
          colorByPoint: true,
          data: chartData,
        },
      ],
    }; */

    //updated new line pattern 
    const chartData = monthLabels.map((month, i) => [
  month,
  this.totalExpenditure[i],
]);

this.chartOptionsMonthWise = {
  chart: {
    type: 'line', // CHANGED from 'column' to 'line'
  },
  title: {
    text: null, // Keep it clean or add a title
  },
  xAxis: {
    type: 'category',
    title: {
      text: 'Aug 2025 - Jul 2026', // ➕ Optional for clarity
    }
  },
  yAxis: {
    title: {
      text: 'Expenditure (in Crore)', //Clear Y-axis label
    },
  },
  tooltip: {
    headerFormat: '<b>{point.key}</b><br>',
    pointFormat: 'Expenditure: {point.y} Crores',
  },
  legend: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  series: [
    {
      type: 'line',
      name: 'Expenditure',
      data: chartData,
      color: '#2196f3', // ➕ Optional: blue line
      marker: {
        enabled: true,
        radius: 4
      },
      lineWidth: 2
    },
  ],
};

  }
  formatAgencyExpenditures(agencyExpenditures: any, index): string {
    let length = Object.keys(agencyExpenditures).length;
    let expendituresList = `${this.response.data.months[index]} Agencies:\n`;
    if (length != 0) {
      const convertToCrores = (data: { [key: string]: number }) => {
        const converted: { [key: string]: string } = {};

        Object.keys(data).forEach((key) => {
          converted[key] = (data[key] / 10000000).toFixed(4) + ' Cr'; // Convert to crores with 4 decimal places
        });

        return converted;
      };
      for (const agency in agencyExpenditures) {
        console.log(agencyExpenditures, agency, 'ac');
        // expendituresList += `${agency}: ${agencyExpenditures[agency]}\n`;
        expendituresList += `${agency}: ${
          convertToCrores(agencyExpenditures)[agency]
        }\n`;
      }
    } else {
      expendituresList = 'No Agency for this Month';
    }

    return expendituresList;
  }

  changeValue(flag) {
    if (flag == 'agency') {
      let data = [];
      let payloadList;
      this.agencyFilter.forEach((element) => {
        let payload = {
          id: element.id,
          name: element.agencyName,
        };
        data.push(payload);
        payloadList = {
          dataList: data,
        };
      });
      this.agencyListAbstract = [];
      this.spinner.show();
      this.ds.getAgencyAbstract(payloadList).subscribe(
        (res: any) => {
          this.agencyListAbstract = res.body.data;
          this.spinner.hide();
        },
        (err) => {
          this.spinner.hide();
        }
      );
    } else if (flag == 'district') {
      let data = [];
      let payloadList;
      this.districtFilter.forEach((element) => {
        let payload = {
          id: element.id,
          name: element.name,
        };
        data.push(payload);
        payloadList = {
          dataList: data,
        };
      });
      this.spinner.show();
      this.districtListAbstract = [];
      this.ds.getDistrcitAbstract(payloadList).subscribe((res: any) => {
        this.districtListAbstract = res.body.data;
        this.spinner.hide();
      });
    }
  }
  getAbstract(flag) {
    this.listName = flag;
    this.collapseAll();
    this.ds.getList().subscribe((res) => {
      this.getList = res.body.data;
      this.agencyListForFilter = this.getList.agencyNames;
      this.districtListForFilter = this.getList.districtNames;
    });
    let date;
    console.log(this.fromDate, 'this.fromDate');
    console.log(this.fromDate, 'this.fromDate');
    if (this.fromDate != '' && this.toDate != '') {
      date = {
        fromDate: this.datePipe.transform(this.fromDate, 'yyyy-MM-dd'),
        toDate: this.datePipe.transform(this.toDate, 'yyyy-MM-dd'),
      };
    } else {
      date = {};
    }
    if (flag == 'agency') {
      this.agencyFilter = '';
      this.spinner.show();
      // let pay = {}
      this.agencyListAbstract = [];
      this.ds.getAgencyAbstract(date).subscribe((res: any) => {
        this.agencyListAbstract = res.body.data;
        this.spinner.hide();
      });
    } else if (flag == 'district') {
      this.districtFilter = '';
      // let pay = {}
      this.spinner.show();
      this.districtListAbstract = [];
      this.ds.getDistrcitAbstract(date).subscribe((res: any) => {
        this.districtListAbstract = res.body.data;
        this.spinner.hide();
      });
    } else if (flag == 'oversna') {
      this.spinner.show();
      this.ds.getOverSNA().subscribe((res: any) => {
        this.overallSNA = res.body.data;
        this.spinner.hide();
      });
    }
  }
  dayWise() {
    this.listName = 'day';
    this.getDayWiseAbstarctReport();
  }
  getDayWiseAbstarctReport() {
    this.ds.getDisbursementData().subscribe((response) => {
      this.disbursementData = response.data;
      this.extractAgencyNames();
    });
  }
  extractAgencyNames(): void {
    const agencySet = new Set<string>();
    this.disbursementData.forEach((entry) => {
      entry.agencies.forEach((agency: any) => agencySet.add(agency.agencyName));
    });
    this.agencyNames = Array.from(agencySet);
  }
  getAmountByAgency(agencies: any[], agencyName: string): number | null {
    const agency = agencies.find((a) => a.agencyName === agencyName);
    return agency ? agency.amountDisbursedByAgency : null;
  }
  getProjectsByAgency(agencies: any[], agencyName: string): number | null {
    const agency = agencies.find((a) => a.agencyName === agencyName);
    return agency ? agency.noOfProjects : null;
  }
  getAgency(entry, agency) {
    this.dayWiseAbstarct = true;
    console.log(this.dayWiseAbstarct, 'this.dayWiseAbstarct');

    let data = entry.agencies.filter((res) => res.agencyName == agency)[0];
    this.courtList = data;
    console.log(this.courtList);
  }
  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
  /* fund(flag, params?) {
    this.spinner.show();
    this.flag = flag;
    if (flag == 'receive') {
      if (params) {
        this.collapseAll();
        let param = {
          fromDate: this.datePipe.transform(this.popupFromDate, 'yyyy-MM-dd'),
          toDate: this.datePipe.transform(this.popuptoDate, 'yyyy-MM-dd'),
        };
        this.ds.getFundReceived(param).subscribe((res: any) => {
          this.fundReceivedData = res.body.data.result;
          this.totalAmountReceived = res.body.data.totalAmountReceived;
          this.noProject = res.body.data.totalNoOfProjects;
          this.fundReceivedDataLength = res.body.data.result.length - 1;
          this.spinner.hide();
        });
      } else {
        this.collapseAll();
        this.popupFromDate = '';
        this.popuptoDate = '';
        this.ds.getFundReceived().subscribe((res: any) => {
          this.fundReceivedData = res.body.data.result;
          this.totalAmountReceived = res.body.data.totalAmountReceived;
          this.noProject = res.body.data.totalNoOfProjects;
          this.fundReceivedDataLength = res.body.data.result.length - 1;
          this.isFundReceived = true;
          this.spinner.hide();
        });
      }
    } else if (flag == 'balance') {
      if (params) {
        this.collapseAll();
        params = {
          fromDate: this.datePipe.transform(this.popupFromDate, 'yyyy-MM-dd'),
          toDate: this.datePipe.transform(this.popuptoDate, 'yyyy-MM-dd'),
        };
        this.ds.getBalance(params).subscribe((res: any) => {
          this.fundReceivedData = res.body.data.result;
          this.fundReceivedDataLength = res.body.data.result.length - 1;
          this.totalAmountReceived = res.body.data.totalAmountReceived;
          this.noProject = res.body.data.totalNoOfProjects;
          this.amountDisburse = res.body.data.totalAmountDisbursed;
          this.amountBalance = res.body.data.totalBalanceAmount;
          this.isFundReceived = true;
          this.spinner.hide();
        });
      } else {
        this.popupFromDate = '';
        this.popuptoDate = '';
        this.collapseAll();
        this.ds.getBalance().subscribe((res: any) => {
          this.fundReceivedData = res.body.data.result;
          this.fundReceivedDataLength = res.body.data.result.length - 1;
          this.totalAmountReceived = res.body.data.totalAmountReceived;
          this.noProject = res.body.data.totalNoOfProjects;
          this.amountDisburse = res.body.data.totalAmountDisbursed;
          this.amountBalance = res.body.data.totalBalanceAmount;
          this.isFundReceived = true;
          this.spinner.hide();
        });
      }
    }
  } */

  fund(flag, params?) {
    this.spinner.show();
    this.flag = flag;

    // Get selected unit ('crore' or 'rupees')
    const selectedUnit = this.unitService.getUnit();

    if (flag === 'receive') {
      this.collapseAll();

      const baseParams: any = {
        unit: selectedUnit, //pass the unit to API
      };

      if (params) {
        baseParams.fromDate = this.datePipe.transform(
          this.popupFromDate,
          'yyyy-MM-dd'
        );
        baseParams.toDate = this.datePipe.transform(
          this.popuptoDate,
          'yyyy-MM-dd'
        );
      }

      this.ds.getFundReceived(baseParams).subscribe((res: any) => {
        this.fundReceivedData = res.body.data.result;
        this.totalAmountReceived = res.body.data.totalAmountReceived;
        this.noProject = res.body.data.totalNoOfProjects;
        this.fundReceivedDataLength = res.body.data.result.length - 1;
        this.isFundReceived = true;
        this.spinner.hide();
      });
    } else if (flag === 'balance') {
      this.collapseAll();

      const baseParams: any = {
        unit: selectedUnit, // pass the unit to API
      };

      if (params) {
        baseParams.fromDate = this.datePipe.transform(
          this.popupFromDate,
          'yyyy-MM-dd'
        );
        baseParams.toDate = this.datePipe.transform(
          this.popuptoDate,
          'yyyy-MM-dd'
        );
      }

      this.ds.getBalance(baseParams).subscribe((res: any) => {
        this.fundReceivedData = res.body.data.result;
        this.fundReceivedDataLength = res.body.data.result.length - 1;
        this.totalAmountReceived = res.body.data.totalAmountReceived;
        this.noProject = res.body.data.totalNoOfProjects;
        this.amountDisburse = res.body.data.totalAmountDisbursed;
        this.amountBalance = res.body.data.totalBalanceAmount;
        this.isFundReceived = true;
        this.spinner.hide();
      });
    }
  }

  noOfProject() {
    this.spinner.show();
    this.totalcount = 0;
    let lable = [];
    let percentage = [];
    this.showPie = false;
    this.selectProject = '';
    this.ds.getNoProjects().subscribe((res: any) => {
      this.getNoOfProjects = res.body.data;
      this.noOfProjects = true;
      this.getNoOfProjects.forEach((element) => {
        this.totalcount += element.totalNoOfProjects;
      });
      this.getNoOfProjects.forEach((element, i) => {
        lable.push(element.agencyName);
      });
      this.getNoOfProjects.forEach((element) => {
        percentage.push(element.totalProjectPercent);
      });
      this.spinner.hide();
    });
  }

/* 

  getData(i) {
    let color = [];
    let percentage = [];
    let lable = [];
    this.selectProject = this.getNoOfProjects[i].projects;
    let indexPercentage = 100 / this.selectProject.length;
    this.selectProject.forEach((element) => {
      color.push(this.getRandomColor());

      lable.push(element.name);
      percentage.push(indexPercentage);
    });
    this.showPie = true;

    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    this.dataforPie = {
      labels: lable,
      datasets: [
        {
          data: percentage,
          backgroundColor: color,
          hoverBackgroundColor: color,
        },
      ],
    };

    this.optionsforPie = {
      plugins: {
        legend: {
          labels: {
            usePointStyle: true,
            color: textColor,
          },
        },
      },
    };
  }

  */ 

  getData(i: number) {
  const color = [];
  const percentage = [];
  const labels = [];

  this.selectProject = this.getNoOfProjects[i].projects;
  const indexPercentage = 100 / this.selectProject.length;

  this.selectProject.forEach((element) => {
    color.push(this.getRandomColor());
    labels.push(element.name);
    percentage.push(indexPercentage);
  });

  this.showPie = true;
  this.layoutFullWidth = false; // Switch to two-column layout
  this.dialogWidth = '100rem';

  const documentStyle = getComputedStyle(document.documentElement);
  const textColor = documentStyle.getPropertyValue('--text-color');

  this.dataforPie = {
    labels: labels,
    datasets: [
      {
        data: percentage,
        backgroundColor: color,
        hoverBackgroundColor: color,
      },
    ],
  };

  this.optionsforPie = {
    plugins: {
      legend: {
        labels: {
          usePointStyle: true,
          color: textColor,
        },
      },
    },
  };
}

resetDialog() {
  this.dialogWidth = '45rem';
  this.showPie = false;
  this.layoutFullWidth = true;
}



  selectData(e) {
    this.spinner.show();
    this.ds.projectMonth(this.month[e.element.index]).subscribe((res: any) => {
      this.agencyDetails = res.body.data;
      this.visible = true;
      this.spinner.hide();
    });
  }
  projectByDepartments(date?) {
    this.ds.projectByCount(date).subscribe((res) => {
      this.disbursementDetails = res.body.data;
      this.getDisbursmentChart();
      console.log(this.disbursementDetails, 'this.disbursementDetails');
    });
  }

  // old circle pattern
  /* getDisbursmentChart() {
    this.chartOptionsHigh = {
      chart: {
        type: 'pie',
        options3d: {
          enabled: true,
          alpha: 45,
        },
        backgroundColor: 'transparent',
      },
      // title: {
      // 	text: 'Disbursement Details'
      //   },
      // plotOptions: {
      //   pie: {
      // 	innerSize: 100,
      // 	depth: 45
      //   }
      // },
      title: {
        text: null, // or text: ''
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          type: 'pie',
          name: 'Amount',
          data: this.disbursementDetails.map((item) => [
            item.agencyName,
            parseFloat((item.expenditure / 10000000).toFixed(2)),
          ]),
        },
      ],
    };
  } */

    //update new circle 3d effect with animation
    getDisbursmentChart() {
  this.chartOptionsHigh = {
    chart: {
      type: 'pie',
      backgroundColor: 'transparent',
      options3d: {
        enabled: true,
        alpha: 55, //Tilt more for better 3D look
        beta: 0,
      },
      animation: {
        duration: 1000, // Smooth animation
      },
      style: {
        fontFamily: 'Arial',
      },
    },
    title: {
      text: null,
    },
    plotOptions: {
      pie: {
        innerSize: 60, // Creates donut effect
        depth: 45,
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.y} Cr',
        },
        shadow: {
          color: 'rgba(0, 0, 0, 0.35)', // Bottom shadow
          offsetX: 0,
          offsetY: 5,
          opacity: 0.3,
          width: 10,
        },
      },
    },
    tooltip: {
      pointFormat: '<b>{point.name}</b>: <b>{point.y} Cr</b>',
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        type: 'pie',
        name: 'Amount',
        data: this.disbursementDetails.map((item) => [
          item.agencyName,
          parseFloat((item.expenditure / 10000000).toFixed(2)),
        ]),
      },
    ],
  };
}


  getFunds(date?) {
    this.ds.getFundReport(date).subscribe((res) => {
      this.fundDtails = res.body.data;
    });
  }
  filter() {
    this.getFunds();
    this.getProjectFundAllocation();
    this.districtWiseCount();
    this.projectByDepartments();
    // this.getDistricts()
    // this.getTotalFund()
    this.getProjectPercentage();
  }
  clear() {
    // this.selectedMonth = '';
    // this.selectedYear = '';
    this.isShowFirstChart = false;
    this.isShowSecondChart = false;
    this.isShowThirdChart = false;
    this.getFunds();
    this.getProjectFundAllocation();
    this.districtWiseCount();
    this.projectByDepartments();
    this.getProjectPercentage();
  }
  get() {}

  //updated year month and week

onYearChange(year: string) {
  this.selectedYear = parseInt(year, 10);
  this.selectedMonth = 0;
  this.selectedWeekIndex = 0;

  this.weeksByMonth = this.dataService.getAllWeeksByMonth(this.selectedYear);
  this.weeks = this.getCombinedWeeksForAllMonths();

  // Add "All weeks" option at the start
  this.weeks = [{ start: 'all', end: 'all' }, ...this.weeks];
}

onMonthChange(month: string) {
  this.selectedMonth = parseInt(month, 10);
  if (this.selectedYear === null) return;

  if (this.selectedMonth === 0) {
    this.weeks = this.getCombinedWeeksForAllMonths();
  } else {
    const key = `${this.selectedYear}-${this.selectedMonth}`;
    this.weeks = this.weeksByMonth[key] || [];
  }

  this.weeks = [{ start: 'all', end: 'all' }, ...this.weeks];
  this.weekCount = this.weeks.length;
  this.selectedWeekIndex = 0;
}

onWeekChange(index: number) {
  this.selectedWeekIndex = index;
  if (index === 0) {
    console.log('All weeks selected');
  } else {
    const selected = this.weeks[index];
    console.log(`Week ${index}:`, selected.start, 'to', selected.end);
  }
}

search(type: 'search' | 'clear') {
  console.log('Search Triggered:', type);
  console.log({
    year: this.selectedYear,
    month: this.selectedMonth,
    week: this.selectedWeekIndex,
    weeks: this.weeks,
  });
}

getCombinedWeeksForAllMonths(): Week[] {
  let combined: Week[] = [];
  Object.keys(this.weeksByMonth).forEach(key => {
    combined = combined.concat(this.weeksByMonth[key]);
  });
  return combined;
}

  // json data code
/*   {
  "2025-1": [
    { "start": "2025-01-01", "end": "2025-01-04" },
    { "start": "2025-01-05", "end": "2025-01-11" },
    { "start": "2025-01-12", "end": "2025-01-18" },
    { "start": "2025-01-19", "end": "2025-01-25" },
    { "start": "2025-01-26", "end": "2025-01-31" }
  ],
  "2025-2": [
    { "start": "2025-02-01", "end": "2025-02-01" },
    { "start": "2025-02-02", "end": "2025-02-15" },
    { "start": "2025-02-16", "end": "2025-02-22" },
    { "start": "2025-02-23", "end": "2025-02-28" }
  ],
  "2025-3": [
    { "start": "2025-03-01", "end": "2025-03-01" },
    { "start": "2025-03-02", "end": "2025-03-08" },
    { "start": "2025-03-09", "end": "2025-03-15" },
    { "start": "2025-03-16", "end": "2025-03-22" },
    { "start": "2025-03-23", "end": "2025-03-29" },
    { "start": "2025-03-30", "end": "2025-03-31" }
  ],
  // ... up to "2025-12"
}*/


//download fucntion use innerthml 

/* generateButtonHtml(flag: string): string {
  if (flag === 'receive') {
    return `
      <button
        class="btn btn-success mb-2"
        (click)="downloadPDF('receive')"
        *ngIf="flag === 'receive'"
      >
        Download Fund Received PDF
      </button>
    `;
  } else {
    return `
      <button
        class="btn btn-success mb-2"
        (click)="downloadPDF('balance')"
        *ngIf="flag === 'balance'"
      >
        Download Fund Balance PDF
      </button>
    `;
  }
} */



// actual download fucntion

downloadPDF(flag?: string) {
  const elementId = flag === 'balance' ? 'fund-balance-pdf' : 'fund-receive-pdf';
  const element = document.getElementById(elementId);

  if (!element) {
    console.error('PDF content not found!');
    return;
  }

  const options = {
    margin: 0.5,
    filename: `${flag === 'balance' ? 'Fund_Balance' : 'Fund_Received'}.pdf`,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' },
  };

  html2pdf().from(element).set(options).save();
}

downloadPDF1() {
    const element = this.pdfContent.nativeElement;
    const opt = {
      margin:       0.5,
      filename:     'projects.pdf',
      image:        { type: 'jpeg', quality: 0.98 },
      html2canvas:  { scale: 2 },
      jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
    };

    html2pdf().set(opt).from(element).save();
  }

// hard dowload method

// with set time out (if without set time not working)
 /*   downloadPDFWithTabFix(): void {
  // Force tab index to 0 (Requisitioning Body Wise)
  this.activeIndex = 0;

  setTimeout(() => {
    const element = document.getElementById('pdf-content');
    if (!element) {
      console.error('pdf-content element not found');
      return;
    }

    html2canvas(element, {
      scale: 2,
      scrollY: -window.scrollY,
      useCORS: true,
    }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('landscape', 'mm', 'a4');
      const imgWidth = pdf.internal.pageSize.getWidth();
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
      pdf.save('expenditure.pdf');
    }).catch((err) => {
      console.error('PDF generation failed:', err);
    });
  }, 300); // Allow tab content to render before capturing
}
 */

// without setTimeOut
 downloadPDF2(): void {
  // Force tab index to 0 (Requisitioning Body Wise)
  this.activeIndex = 0;


    const element = document.getElementById('pdf-content');
    if (!element) {
      console.error('pdf-content element not found');
      return;
    }

    html2canvas(element, {
      scale: 2,
      scrollY: -window.scrollY,
      useCORS: true,
    }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('landscape', 'mm', 'a4');
      const imgWidth = pdf.internal.pageSize.getWidth();
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
      pdf.save('expenditure.pdf');
    }).catch((err) => {
      console.error('PDF generation failed:', err);
    });
  }; // Allow tab content to render before capturing





}